package com.shadowings.gero.data.lessons.chapter6
import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter1.famousNames
import com.shadowings.gero.data.lessons.chapter2.animalNames
import com.shadowings.gero.data.lessons.chapter2.foodNames
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodContent
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansContent
import com.shadowings.gero.data.lessons.chapter2.humanNames
import com.shadowings.gero.data.lessons.chapter3.vocabVarieWords
import com.shadowings.gero.data.lessons.chapter4.royalNameWordIds
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs1Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs2Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs3Content
import com.shadowings.gero.data.lessons.chapter5.toHieroList
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs1WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs2WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs3WordIds
import com.shadowings.gero.data.lessons.toHieroExplanation


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_hiero_verbs_3_alyn
import gero.composeapp.generated.resources.exp_content_hiero_verbs_3_zeta
import gero.composeapp.generated.resources.exp_title_hiero_verbs_3_intro

fun getHieroVerbs4Content(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {

    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_hiero_verbs_3_intro,
            content = Res.string.exp_content_hiero_verbs_3_zeta,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_hiero_verbs_3_intro,
            content = Res.string.exp_content_hiero_verbs_3_alyn,
            face = Faces.Perfect,
            character = Characters.Alyn,
        ),
    )
    val previous =
        (famousNames + foodNames + animalNames + humanNames + vocabVarieWords + royalNameWordIds + vocabVerbs1WordIds + vocabVerbs2WordIds + vocabVerbs3WordIds).toHieroList(
            words
        )
    val current = vocabVerbs4WordIds.toHieroList(words)

    return intro + current.filter { it !in previous }.toHieroExplanation(hiero, languageCode).map {
        return@map it.copy(
            character = Characters.Zeta
        )
    }
}

fun getHieroVerbs4QuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val previousContent = getHieroFoodContent(hiero, words, languageCode) +
            getHieroAnimalsContent(hiero, words, languageCode) +
            getHieroHumansContent(hiero, words, languageCode) +
            getHieroVerbs1Content(hiero, words, languageCode) +
            getHieroVerbs2Content(hiero, words, languageCode) +
            getHieroVerbs3Content(hiero, words, languageCode)
    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getHieroVerbs4Content(hiero, words, languageCode),
        languageCode = languageCode,
        previousHieroContent = previousContent
    )
}



